import React, { useState } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import { DropzoneArea } from "material-ui-dropzone";
import { set } from "lodash";
import { useEdgePinchFilePost } from "../../../../common/services/fileServices";
import { useFetchContext } from "../../../../common/FetchContext";
import { processErrorOnMutation } from "../../../../../util/errorMessaging";


export const EdgeFileUploadStage = ({
    asset,
    selectedFile,
    setSelectedFile,
    setTableData,
    setTableDatashow,
    onContinue,
}: any) => {

    const [loading, setLoading] = useState(false);
    const { authAxios } = useFetchContext();

    const { mutateAsync: edgePinchFiles } = useEdgePinchFilePost();

    // const handleFileChange = (
    //     event: React.ChangeEvent<HTMLInputElement>
    // ) => {
    //     const file = event.target.files?.[0] || null;
    //     setSelectedFile(file);
    // };

    const handleFileChange = (files: File[]) => {
        const file = files[0] || null;
        setSelectedFile(file);
    };

    const handleUpload = async () => {
        try {
            setLoading(true);


            // API CALL
            const response = await edgePinchFiles({
                authAxios,
                selectedFile: selectedFile,
                asset_id: asset,

            });






            setTableData(response.data);
            setTableDatashow(response);



            toast.success("File uploaded successfully");

            onContinue();

        } catch (err: any) {

           

            toast.error(`Error while uploading file`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Typography variant="h6">
                Upload Edge Pinch File
            </Typography>

            <Box mt={2} >
                <DropzoneArea
                    acceptedFiles={[
                        ".xlsx",
                        ".xls",
                    ]}
                    dropzoneText="Drag and drop an Excel file here or click"
                    filesLimit={1}
                    onChange={handleFileChange}
                    showAlerts={false}
                />
            </Box>

            <Box mt={3}>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!selectedFile || loading}
                    onClick={handleUpload}
                >
                    Submit
                </Button>
            </Box>
        </>
    );
};

